module.exports = __webpack_public_path__ + "static/learning_room_2-efe09c1e7c59da5d322dcc07c031d5bd.jpg";